import LinkComponent from "@/components/elements/LinkComponent";

export function RichTextLink({
  type,
  with_icon,
  url,
  title,
}: Partial<LinkElement>) {
  return (
    <LinkComponent
      type={type || "internal"}
      with_icon={with_icon || false}
      url={url || "/"}
    >
      {title}
    </LinkComponent>
  );
}
